import { Slider } from '@mui/material';
import theme from 'theme';
import { withStyles } from 'tss-react/mui';

const thumbColor = theme.palette.info.main;

// Grabbing style slider thumb size to properly add horizontal padding on the responsive container, otherwise the thumbs clip
export const thumbSize = 18;

const StyledSlider = withStyles(
  Slider,
  (theme, _params, classes) => ({
    root: {
      color: theme.palette.primary.main,
      height: 3,
      padding: '13px 0',
    },
    thumb: {
      color: thumbColor,
      height: thumbSize,
      width: thumbSize,
      backgroundColor: thumbColor,
      boxShadow: theme.shadows[6],
      '&:focus, &:hover, &.Mui-active': {
        boxShadow: theme.shadows[8],
      },
    },
    active: {},
    track: {
      height: 1,
    },
    rail: {
      color: theme.palette.action.active,
      opacity: 1,
      height: theme.dimensions.rail.height,
    },
  }),
  { withTheme: true }
);

export default StyledSlider;
